export const icons = {
  // GENERAL
  EDIT: 'ni ni-edit',
  DELETE: 'ni ni-trash',
  ADD: 'ni ni-plus',
  VIEW: 'ni ni-eye',
  CHECK: 'ni ni-check',
  CLOSE: 'ni ni-cross',
  DOCUMENT: 'ni ni-file-text',
  CALENDAR: 'ni ni-calendar-alt',
  INFO: 'ni ni-info',
  WARNING: 'ni ni-alert-circled',
  ERROR: 'ni ni-cross-circled',
  SUCCESS: 'ni ni-check-circled',
  SEARCH: 'ni ni-search',
  REFRESH: 'ni ni-refresh',
  SETTINGS: 'ni ni-settings',
  SHARE: 'ni ni-share',
  TAG: 'ni ni-tag',

  // LEGAL
  CO_OWNERS: 'ni ni-users',
  SHARE_ENCUMBRANCE: 'ni ni-coins',
  NOTARIAL_REGISTRATION: 'ni ni-article',
  NOTARY_NAME: 'ni ni-user-list',
  NOTARY_PROTOCOL: 'ni ni-article',
  NOTARY_CITY: 'ni ni-map-pin',
};
